export enum PageSize {
  Brochure = '8 x 8',
  Calendar = '11 x 17',
  Letter = '8.5 x 11',
}
